<template>
  <section id="outgoingCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog v-if="active" :active="active" module="chatReport" @dialog:change="eventdialog"></RangeDateDialog>
    <!-- FIN MODAL DE RANGO DE FECHA -->

    <v-card class="shadow-1 mt-5 mt-md-10">
      <!-- <v-card-text> -->
      <v-tabs dark grow center-active v-model="tab" background-color="secondary lighten-1">
        <v-tab v-for="(item, index) in filteredTabHeaders" :key="index" @click="getInfo(item)">
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in filteredTabHeaders" :key="item">
          <v-card flat>
            <!-- <v-card-text> -->
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-switch
                    class="ml-auto d-flex d-md-none"
                    v-model="showMobileGraph"
                    inset
                    label="Ver gráficas"
                  ></v-switch>
                </v-col>

                <v-col v-show="!showMobileGraph" cols="12" md="6">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Nombre</th>
                          <th class="text-right">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in desserts" :key="item.name">
                          <template v-if="isLoading">
                            <td class="text-right">
                              <v-skeleton-loader type="list-item"></v-skeleton-loader>
                            </td>
                            <td class="text-right">
                              <v-skeleton-loader class="ml-auto" style="width: 20%" type="text"></v-skeleton-loader>
                            </td>
                          </template>
                          <template v-else>
                            <td>
                              {{ item.name }}
                            </td>
                            <td class="text-right">
                              {{ item.total }}
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>

                <v-col cols="12" md="6" v-show="showMobileGraph">
                  <!-- tabs de las graficas -->
                  <v-card outlined>
                    <v-tabs v-model="graphTab" background-color="transparent" color="primary" grow>
                      <v-tab> Chats atendidos por agente </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="graphTab">
                      <v-tab-item>
                        <v-card flat v-if="render">
                          <apexchart ref="chart2Queue" type="bar" :options="optionsBar" :series="serieBar"></apexchart>
                        </v-card>

                        <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image">
                        </v-skeleton-loader>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6" class="d-none d-md-flex">
                  <!-- tabs de las graficas -->
                  <v-card outlined style="width: 100%">
                    <v-tabs v-model="graphTab" background-color="transparent" color="primary">
                      <v-tab> Chats atendidos por agente </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="graphTab">
                      <v-tab-item>
                        <v-card flat v-if="render">
                          <apexchart ref="chart2Queue" type="bar" :options="optionsBar" :series="serieBar"></apexchart>
                        </v-card>

                        <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image">
                        </v-skeleton-loader>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <!-- </v-card-text> -->
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <!-- </v-card-text> -->
    </v-card>
  </section>
</template>

<script>
// import { mapState } from "vuex";
import moment from "moment";
import RangeDateDialog from "@/components/DatePickers/DateRangePicker.vue";
import { PbxHttpClient } from "@/services";

moment.locale("es");
const generateDonutOptions = (labels) => ({
  chart: {
    type: "donut",
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: "100%",
        },
      },
    },
  ],
  width: "100%",
  legend: {
    position: "bottom",
  },
  labels,
});

export default {
  inject: ["theme"],

  components: {
    RangeDateDialog,
  },

  data() {
    return {
      active: false,
      isLoading: false,
      rangeDateDialog: false,
      datesRange: ["2019-09-10", "2019-09-20"],
      dialog: false,
      render: false,
      showMobileGraph: false,
      tab: null,
      tabHeaders: ["Dia", "Mes", "Año", "Personalizado"],
      customSearchDateRange: null,
      graph: ["Chats atendidos por agente"],
      desserts: [
        { name: "Tiempo de respuesta inicial", total: 0 },
        { name: "Tiempo de resolución", total: 0 },
        { name: "Numero de chats atendidos por agente", total: 0 },
        { name: "Duración promedio de los chats", total: 0 },
        { name: "Tasa de Respuesta", total: `0 %` },
      ],
      // Graphs
      serieBar: [
        {
          name: "Chats",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      optionsBar: {
        xaxis: {
          categories: [],
        },

        // fill: {
        //     colors: ["#625FA4"]
        // },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 3,
          opacity: 0.5,
        },
      },
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },

    dateRangeText() {
      return this.dates.join(" ~ ");
    },

    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    filteredTabHeaders() {
      if (this.CurrentRole === 10) return ["Dia", "Personalizado"];
      return this.tabHeaders;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.getInfo("Dia");
    this.changeThemeChart();
  },

  updated() {
    this.changeThemeChart();
  },

  methods: {
    eventdialog(value) {
      this.active = false;
      if (value !== "cerrar") {
        this.getInfo("Personalizado", value.date);
      } else {
        this.tab = 0;
        this.getInfo("Dia");
      }
    },

    /**
     * @param {"Dia" | "Mes" | "Año" | "Personalizado"} format
     */
    async getInfo(format, customValue = null) {
      const isCustom = format.charAt(0) === "P";
      if (this.isLoading && !customValue) return;
      // Activamos loader y ocultamos gráficas (Para búsquedas personalizadas)
      this.render = false;
      this.isLoading = true;
      this.activeGraphDonut = false;
      this.activeGraphIncoming = false;
      this.activeGraphOutgoing = false;

      this.customSearchDateRange = null;
      try {
        if (isCustom && !customValue) {
          this.active = true;
          return;
        }
        this.$store.commit("layout/SET_OVERLAY", {
          value: true,
          title: "Cargando",
        });

        const value = isCustom
          ? customValue
          : format.charAt(0) === "D"
          ? moment().format("YYYY-MM-DD")
          : format.charAt(0) === "M"
          ? {
              start: moment()
                .startOf("month")
                .format("YYYY-MM-DD"),
              end: moment()
                .endOf("month")
                .format("YYYY-MM-DD"),
            }
          : {
              start: moment()
                .startOf("year")
                .format("YYYY-MM-DD"),
              end: moment()
                .endOf("year")
                .format("YYYY-MM-DD"),
            };

        const request = {
          format: format.charAt(0),
          value: value,
        };

        const { data } = await PbxHttpClient.post("/whatsapps/chat/reportChat", request);

        this.render = true;
        this.generateGraphicAndTable(data);
      } catch (error) {
        console.error("error getting chat reports", error);
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    generateGraphicAndTable(response) {
      const {
        initial_response_time,
        resolution_time,
        chats_handled_by_agent,
        average_chat_duration,
        response_rate,
      } = response;

      // segunda grafica
      this.optionsBar.xaxis.categories = chats_handled_by_agent.map((el) => el.user_name || el.userId);

      this.serieBar[0].data = chats_handled_by_agent.map((el) => el.chats_handled);

      // Tabla
      this.desserts = [
        {
          name: "Tiempo de respuesta inicial",
          total: initial_response_time,
        },
        {
          name: "Tiempo de resolución",
          total: resolution_time,
        },
        {
          name: "Numero de chats atendidos por agente",
          total:
            chats_handled_by_agent?.map((el) => el.chats_handled).reduce((acc, el) => +acc + +el, 0) /
              chats_handled_by_agent.length || 0,
        },
        {
          name: "Duración promedio de los chats",
          total: `${average_chat_duration}`,
        },
        {
          name: "Tasa de Respuesta",
          total: `${response_rate} %`,
        },
      ];

      // Renderizamos al final la gráfica luego de pintar datos
      this.render = true;
    },

    changeThemeChart() {
      if (this.isDark) {
        this.$refs.chart2Queue?.updateOptions({ theme: { mode: "dark" } }, true);
      } else {
        this.$refs.chart2Queue?.updateOptions({ theme: { mode: "light" } }, true);
      }
    },

    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>
<style>
#detailsTable .v-data-footer__select {
  display: none;
}
</style>
